/**
 * `#pm` — `template.html` dòng 837–894.
 *
 * Ba view đều nằm trong HTML, không lazy nội dung (design doc §8.8): chúng là nội dung thật,
 * chỉ HÀNH VI tab mới tách chunk.
 */

/**
 * Một hàng WBS. `level` và `tone` khai union tại nguồn thay vì để suy ra `number`/`string` —
 * cùng lý do với `tint` ở `hero.ts`: chỗ dùng khỏi ép kiểu, gõ sai là lỗi biên dịch ở đây.
 */
interface WbsRow {
  readonly code: string;
  readonly label: string;
  readonly percent: string;
  readonly level: 0 | 1;
  readonly tone: 'done' | 'running' | 'idle';
}

const wbsRows: readonly WbsRow[] = [
  { code: '1.0', label: 'Chuẩn bị', percent: '100%', level: 0, tone: 'done' },
  { code: '1.1', label: 'Rà soát hạ tầng', percent: '100%', level: 1, tone: 'done' },
  { code: '2.0', label: 'Triển khai', percent: '62%', level: 0, tone: 'running' },
  { code: '2.1', label: 'Deploy theo giai đoạn', percent: '70%', level: 1, tone: 'running' },
  { code: '2.2', label: 'Truyền thông khách hàng', percent: '30%', level: 1, tone: 'idle' },
  { code: '3.0', label: 'Sau ra mắt', percent: '0%', level: 0, tone: 'idle' },
];

export const pm = {
  eyebrow: 'Quản lý dự án',
  heading: 'Đội đang bàn về công việc cũng chính là đội sở hữu công việc.',
  lead: 'Bắt đầu dự án trên bất kỳ channel nào và chọn phương pháp phù hợp: Sprint theo chu kỳ, Kanban liên tục, hoặc WBS phân cấp. Đổi phương pháp sau vẫn giữ nguyên task.',
  tabs: ['Sprint', 'Kanban', 'WBS'],
  sprint: {
    title: 'Sprint 14 · Atlas 4.0',
    status: 'ĐANG CHẠY',
    /*
     * Thiết kế đặt mũi tên U+2192 giữa hai mốc ngày. Ở đây dùng `–` (en dash): lô 0 ĐO ĐƯỢC
     * rằng không `@font-face` nào trong bundle thiết kế phủ U+2192 và không file nguồn nào
     * có glyph cho nó (ghi trong `script/gen-fonts.mjs`), nên nó sẽ rơi về font hệ thống —
     * lệch nét ngay giữa một dòng chữ. `–` nằm trong subset `latin` và là dấu chuẩn cho
     * khoảng thời gian.
     */
    range: '02/07 – 16/07',
    progressStrong: '17/25',
    progressLabel: 'task hoàn tất · còn 6 ngày',
    /** Số, không phải chuỗi: nó đi vào `aria-valuenow` và vào `width` của thanh tiến độ. */
    percent: 68,
    stats: [
      { value: '25', label: 'Task cam kết' },
      { value: '3', label: 'Blocker còn mở' },
      { value: '6', label: 'Task của tôi' },
      { value: '2', label: 'Chờ review' },
    ],
    chips: ['Phase: Launch', 'Kế tiếp: Sprint 15 (17/07)', 'Channel liên kết: #q2-launch'],
  },
  kanban: {
    columns: [
      { title: 'BACKLOG · 9', cards: ['Rà soát copy onboarding', 'Spec push mobile'] },
      { title: 'CẦN LÀM · 4', cards: ['Soạn runbook rollback', 'Bảng QA sign-off'] },
      { title: 'ĐANG LÀM · 3', cards: ['Báo cáo launch readiness', 'Trang pricing v2'] },
      { title: 'CHỜ REVIEW · 2', cards: ['Script migration'] },
      { title: 'HOÀN TẤT · 11', cards: ['Design QA pass'] },
    ],
  },
  wbs: {
    title: 'WBS — Triển khai Atlas 4.0',
    rows: wbsRows,
  },
};
